/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUsernameRequestDto } from '../../models/set-username-request-dto';
import { UserResponseAdminUserDto } from '../../models/user-response-admin-user-dto';

export interface AdminAuthControllerSetUsernameV1$Params {
      body: SetUsernameRequestDto
}

export function adminAuthControllerSetUsernameV1(http: HttpClient, rootUrl: string, params: AdminAuthControllerSetUsernameV1$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseAdminUserDto>> {
  const rb = new RequestBuilder(rootUrl, adminAuthControllerSetUsernameV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserResponseAdminUserDto>;
    })
  );
}

adminAuthControllerSetUsernameV1.PATH = '/v1/admin/auth/username';
